// extracted by mini-css-extract-plugin
module.exports = {"button":"PanelNavigation_button__36IbX","cross":"PanelNavigation_cross__1rjsX"};